import { z } from 'zod/v4';

import { FormatFieldSchema } from './fields';

// Reusable legend configuration
export const LegendConfigSchema = z.object({
    position: z.enum(['none', 'top', 'left', 'right', 'bottom']).default('none'),
});

// Shared axis configuration
export const AxisConfigSchema = z.object({
    title: z.string().optional(),
    format: FormatFieldSchema,
    orientation: z.enum(['left', 'right', 'none']).default('none'),
    logarithmic: z.boolean().optional(),
});

// Common tooltip settings
export const TooltipConfigSchema = z.object({
    enabled: z.boolean().default(true),
    format: FormatFieldSchema.optional(),
});
